import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgenticSoc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.629 6.662a2.05 2.05 0 0 1 2.123.493 2 2 0 0 1 0 2.825L10.14 16.6a1.993 1.993 0 0 1-2.821 0 2.06 2.06 0 0 1-.492-2.126 1.135 1.135 0 0 0-1.45-1.45 2.05 2.05 0 0 1-2.122-.494 2 2 0 0 1 0-2.825l2.03-2.034h.002l4.58-4.586a2.02 2.02 0 0 1 3.312 2.126 1.136 1.136 0 0 0 1.45 1.451M6.697 9.024a.75.75 0 0 1 1.06 0l1.25 1.249a.75.75 0 0 1-1.061 1.06l-1.25-1.248a.75.75 0 0 1 0-1.061m3.893 2.896a.75.75 0 1 0-1.068 1.053l.297.301a.75.75 0 0 0 1.068-1.053z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAgenticSoc;
